import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=47226123&scoped=true"
import script from "./FullScreen.vue?vue&type=script&lang=js"
export * from "./FullScreen.vue?vue&type=script&lang=js"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=47226123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47226123",
  null
  
)

export default component.exports